import { css } from 'styled-components'

export default css`
  .TextInput {
    width: 100%;
  }
`
